export const BASE_URL = "https://frontend-test-api.aircall.io/";
export const CALLS_URL = "calls/";
export const LOGIN_URL = "auth/login";
export const CHANNEL_NAME = "private-aircall";
export const EVENT_NAME = "update-call";
export const APP_KEY = "d44e3d910d38a928e0be";
export const AUTH_ENDPOINT = "https://frontend-test-api.aircall.io/pusher/auth";
export const CLUSTER = "eu";
export const TOAST_DEFAULT_CONFIG = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  progress: undefined,
};
